// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.parent[data-v-349483f8] {\n    display: flex;\n    align-items: center;\n}\n\n", "",{"version":3,"sources":["webpack://./resources/js/components/UI/Alert.vue"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":["\n.parent[data-v-349483f8] {\n    display: flex;\n    align-items: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
